import { Edit, useForm  } from "@refinedev/antd";
import { HttpError } from '@refinedev/core';
import { Form, Input } from "antd";


export const AdminEdit = () => {
    const { formProps, saveButtonProps, query, formLoading } = useForm<any, HttpError, any>({
        resource: "admin",
        successNotification: (data) => {
            return {
                message: data?.data.message,
                type: "success",
            };
        },
        action: "edit",
    });

    const user = query?.data?.data?.data;
    // console.log("Query:", query);
    // console.log("Admin:", user)

    return (
        <Edit
            saveButtonProps={saveButtonProps}
            isLoading={formLoading}
            resource="admin"
            mutationMode="optimistic"
            title="Edit Admin"
        >
            <Form 
                {...formProps} 
                layout="vertical"
                initialValues={{
                    ...formProps.initialValues,
                    percentage:
                        formProps.initialValues && formProps.initialValues.percentage
                            ? formProps.initialValues.percentage * 100
                            : null,
                }}>
                <Form.Item
                    label={"Full name"}
                    name={["fullName"]}
                    initialValue={user?.fullName}
                    rules={[
                        {
                            required: true,
                        }
                    ]}
                >
                    <Input />
                </Form.Item>
            </Form>
        </Edit>
    )
}